import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { message } from 'antd';
import { casesService } from '../services/api.service';
import Layout from '../components/Layout';
import CaseList from '../components/case/CaseList';
import PermissionGuard from "../components/PermissionGuard";
import { PERMISSIONS } from "../config/permissionsConfig";
import { useLocation } from 'react-router-dom';

export default function Cases() {
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [cases, setCases] = useState([]);
    const [stats, setStats] = useState({
        total: 0,
        active: 0,
        pending: 0,
        suspended: 0,
        closed: 0,
        highPriority: 0
    });
    const initialClientData = location.state?.clientData || null;

    const fetchCases = async () => {
        try {
            setLoading(true);
            const data = await casesService.getCases();
            setCases(data);

            // Calculate stats
            const newStats = {
                total: data.length,
                active: data.filter(c => c.status === 'جديدة').length,
                pending: data.filter(c => c.status === 'جارية').length,
                suspended: data.filter(c => c.status === 'معلقة').length,
                closed: data.filter(c => c.status === 'مغلقة').length,
                highPriority: data.filter(c => c.priority === 'high').length
            };
            setStats(newStats);

        } catch (err) {
            if (err.response?.status === 401) {
                window.location.href = '/login';
            } else {
                setError(err.message || 'حدث خطأ في جلب القضايا');
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCases();
    }, []);

    return (
        <Layout>
            <Helmet>
                <title>إدارة القضايا - نظام إدارة المكتب</title>
            </Helmet>
            
            <div className="container mx-auto px-4 py-8" dir="rtl">
                <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-3">
                    <h1 className="text-2xl font-bold text-gray-800">
                        إدارة القضايا
                    </h1>
                </div>

                {/* Stats Cards */}
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-6">
                    <div className="bg-white overflow-hidden shadow rounded-lg">
                        <div className="px-4 py-5 sm:p-6">
                            <dl>
                                <dt className="text-sm font-medium text-gray-500 truncate">
                                    إجمالي القضايا
                                </dt>
                                <dd className="mt-1 text-3xl font-semibold text-gray-900">
                                    {stats.total}
                                </dd>
                            </dl>
                        </div>
                    </div>
                    <div className="bg-white overflow-hidden shadow rounded-lg">
                        <div className="px-4 py-5 sm:p-6">
                            <dl>
                                <dt className="text-sm font-medium text-gray-500 truncate">
                                    قضايا نشطة
                                </dt>
                                <dd className="mt-1 text-3xl font-semibold text-green-600">
                                    {stats.active}
                                </dd>
                            </dl>
                        </div>
                    </div>
                    <div className="bg-white overflow-hidden shadow rounded-lg">
                        <div className="px-4 py-5 sm:p-6">
                            <dl>
                                <dt className="text-sm font-medium text-gray-500 truncate">
                                    قيد النظر
                                </dt>
                                <dd className="mt-1 text-3xl font-semibold text-blue-600">
                                    {stats.pending}
                                </dd>
                            </dl>
                        </div>
                    </div>
                    <div className="bg-white overflow-hidden shadow rounded-lg">
                        <div className="px-4 py-5 sm:p-6">
                            <dl>
                                <dt className="text-sm font-medium text-gray-500 truncate">
                                    قضايا معلقة
                                </dt>
                                <dd className="mt-1 text-3xl font-semibold text-yellow-600">
                                    {stats.suspended}
                                </dd>
                            </dl>
                        </div>
                    </div>
                    <div className="bg-white overflow-hidden shadow rounded-lg">
                        <div className="px-4 py-5 sm:p-6">
                            <dl>
                                <dt className="text-sm font-medium text-gray-500 truncate">
                                    قضايا مغلقة
                                </dt>
                                <dd className="mt-1 text-3xl font-semibold text-gray-600">
                                    {stats.closed}
                                </dd>
                            </dl>
                        </div>
                    </div>
                    <div className="bg-white overflow-hidden shadow rounded-lg">
                        <div className="px-4 py-5 sm:p-6">
                            <dl>
                                <dt className="text-sm font-medium text-gray-500 truncate">
                                    أولوية عالية
                                </dt>
                                <dd className="mt-1 text-3xl font-semibold text-red-600">
                                    {stats.highPriority}
                                </dd>
                            </dl>
                        </div>
                    </div>
                </div>

                <CaseList 
                    cases={cases} 
                    loading={loading} 
                    error={error} 
                    onRefresh={fetchCases}
                    initialClientData={initialClientData}
                />
            </div>
        </Layout>
    );
}